// extracted by mini-css-extract-plugin
export default {"text":"ContactFormModal_text__jd7Nw"};